<template>
  <div class="print-pay-fee-container">
    <div class="text-center">
      <div style="color:#000;font-size:26px">{{printPayFeeInfo.communityName}}
        <span v-if="printPayFeeInfo.apply === 'Y'">{{ $t('printPayFeeElectric.apply') }}</span>
        <span v-if="printPayFeeInfo.apply === 'N'">{{ $t('printPayFeeElectric.receipt') }}</span>
        <span v-if="printPayFeeInfo.apply === 'R'">{{ $t('printPayFeeElectric.refund') }}</span>
      </div>
    </div>
    <div style="color:#000;font-size:18px;margin-left:20px">
      <div class="float-left">
        <span></span>
        <br />
        {{ $t('printPayFeeElectric.owner') }}：{{printPayFeeInfo.payObjName}}
      </div>
      <div class="float-right text-right">
        <span>{{ $t('printPayFeeElectric.receiptNum') }}{{printPayFeeInfo.receiptNum}}</span>
        <br />
        <span>{{ $t('printPayFeeElectric.payTime') }}：{{printPayFeeInfo.feeTime}}</span>
      </div>
    </div>

    <table class="table vc-table-border" style="color:#000;font-size:18px;width:100%;border-collapse:collapse;">
      <thead>
        <tr>
          <th class="text-center" width="60px">{{ $t('printPayFeeElectric.serialNumber') }}</th>
          <th class="text-center">{{ $t('printPayFeeElectric.feeItem') }}</th>
          <th class="text-center">{{ $t('printPayFeeElectric.houseCar') }}</th>
          <th class="text-center">{{ $t('printPayFeeElectric.feeRange') }}</th>
          <th class="text-center" v-if="showUnitPriceColumn">{{ $t('printPayFeeElectric.unitPrice') }}</th>
          <th class="text-center">{{ $t('printPayFeeElectric.areaUsage') }}</th>
          <th class="text-center" v-if="showSplitColumns">{{ $t('printPayFeeElectric.waterElectricAmount') }}</th>
          <th class="text-center" v-if="showSplitColumns">{{ $t('printPayFeeElectric.serviceAmount') }}</th>
          <th class="text-center">{{ $t('printPayFeeElectric.paymentMethod') }}</th>
          <th class="text-center">{{ $t('printPayFeeElectric.receivableActual') }}</th>
          <th class="text-center">{{ $t('printPayFeeElectric.discountAmount') }}</th>
          <th class="text-center" width="200px">{{ $t('printPayFeeElectric.remark') }}</th>
        </tr>
      </thead>
      <tbody style="color:#000;font-size:20px">
        <tr v-for="(item,index) in printPayFeeInfo.fees" :key="index" class="vc-table-border">
          <th scope="row" class="text-center">{{index + 1}}</th>
          <td class="text-center">{{item.feeName}}</td>
          <td class="text-center">{{item.objName}}</td>
          <td class="text-center">
            <div v-if="item.preDegrees">
              {{dateFormat(item.startTime)}}
              <span>{{ $t('printPayFeeElectric.to') }}</span>
              {{dateFormat(item.endTime)}}<br />
              {{item.preDegrees}} {{ $t('printPayFeeElectric.to') }} {{item.curDegrees}}
            </div>
            <div v-else-if="item.feeTypeCd === '888800010006'">
              {{ $t('printPayFeeElectric.none') }}
            </div>
            <div v-else>
              {{dateFormat(item.startTime)}}{{$t('printPayFeeElectric.to')}}{{dateFormat(item.endTime)}}
            </div>
          </td>
          <td class="text-center" v-if="showUnitPriceColumn">
            <span v-if="isMeterFee(item)">{{item.squarePrice}}<br />{{item.units}}</span>
            <span v-else>{{item.squarePrice || '—'}}</span>
          </td>
          <td class="text-center">{{item.area}}</td>
          <td class="text-center" v-if="showSplitColumns">{{formatElectricAmount(item.electricAmount)}}</td>
          <td class="text-center" v-if="showSplitColumns">{{formatServiceAmount(item.serviceAmount)}}</td>
          <td class="text-center">{{item.primeRate}}</td>
          <td class="text-center">
            {{item.receivableAmount}}/{{item.amount}}{{$t('printPayFeeElectric.yuan')}}
            <span v-if="isRefund(item)">({{ $t('printPayFeeElectric.refund') }})</span>
          </td>
          <td class="text-center">{{formatDiscount(item.discountPrice)}}</td>
          <td class="text-center">{{item.remark}}</td>
        </tr>
        <tr>
          <td :colspan="totalColumns - 7" class="text-center">{{ $t('printPayFeeElectric.capitalRMB') }}</td>
          <td colspan="2" class="text-center">{{changeNumMoneyToChinese(printPayFeeInfo.amount)}}</td>
          <td colspan="2" class="text-center">{{printPayFeeInfo.amount}}</td>
          <td colspan="1" class="text-center">{{ $t('printPayFeeElectric.accountDeduction') }}</td>
          <td colspan="2" class="text-center">{{printPayFeeInfo.acctAmount}}</td>
        </tr>
        <tr v-if="hasServiceFee">
          <td :colspan="totalColumns - 8" class="text-center">
            {{ $t('printPayFeeElectric.waterElectricTotal') }} ¥{{printPayFeeInfo.electricTotal}}
          </td>
          <td colspan="3" class="text-center">
            {{ $t('printPayFeeElectric.serviceTotal') }} ¥{{printPayFeeInfo.serviceTotal}}
          </td>
          <td colspan="5" class="text-center" style="color:#888;font-size:16px;">
            {{ $t('printPayFeeElectric.checkNote') }}
            ({{printPayFeeInfo.electricTotal}} + {{printPayFeeInfo.serviceTotal}} = {{printPayFeeInfo.splitTotal}})
          </td>
        </tr>
        <tr v-if="printPayFeeInfo.content || printPayFeeInfo.qrImg">
          <td :colspan="totalColumns - 5">
            <div style="max-width: 600px;" v-html="printPayFeeInfo.content"></div>
          </td>
          <td colspan="5">
            <img v-if="printPayFeeInfo.qrImg" :src="printPayFeeInfo.qrImg" width="100px" height="100px">
          </td>
        </tr>
      </tbody>
    </table>

    <el-row style="color:#000;font-size:18px;margin-left: 10px;" class="flex justify-between">
      <el-col :span="6">{{ $t('printPayFeeElectric.departmentHead') }}</el-col>
      <el-col :span="6">{{ $t('printPayFeeElectric.operator') }}：{{userInfo.name}}</el-col>
      <el-col :span="6">{{ $t('printPayFeeElectric.financeReceipt') }}</el-col>
      <el-col :span="6">{{ $t('printPayFeeElectric.customerConfirm') }}</el-col>
    </el-row>

    <el-row id="print-btn">
      <el-col :span="24">
        <el-button type="primary" class="float-right" @click="handlePrint">
          <i class="el-icon-printer"></i>&nbsp;{{ $t('common.print') }}
        </el-button>
        <el-button type="warning" class="float-right" style="margin-right:20px;" @click="handleClose">
          {{ $t('common.cancel') }}
        </el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getCommunityId, getCommunityName } from '@/api/community/communityApi'
import { queryFeeReceipt, queryFeeReceiptDetail, queryFeePrintSpec } from '@/api/fee/printPayFeeApi'
import { getUserId, getUserName } from '@/api/user/userApi'
import { dateFormat } from '@/utils/dateUtil'
import { changeNumMoneyToChinese } from '@/utils/moneyUtil'

export default {
  name: 'PrintPayFeeElectric',
  data() {
    return {
      printPayFeeInfo: {
        communityName: '',
        receiptId: '',
        receiptIds: '',
        detailIds: '',
        roomName: '',
        amount: 0.00,
        fees: [],
        feeTime: '',
        wechatName: '',
        content: '',
        qrImg: '',
        payObjName: '',
        feeReceipt: [],
        apply: 'N',
        receiptNum: '',
        acctAmount: 0,
        electricTotal: '0.00',
        serviceTotal: '0.00',
        splitTotal: '0.00'
      },
      userInfo: {},
      printFlag: '0',
      communityId: ''
    }
  },
  computed: {
    // 本次打印是否包含多个收费单据（多张收据）
    isMultiReceipt() {
      return (this.printPayFeeInfo.feeReceipt || []).length > 1
    },
    // 是否含服务费（存在拆分金额：5006/9010 且服务费单价>0）
    hasServiceFee() {
      return this.printPayFeeInfo.fees.some(item => parseFloat(item.serviceAmount || 0) > 0)
    },
    // 单价列：多个收费单据时一律显示；单个单据时，无服务费才显示
    showUnitPriceColumn() {
      return this.isMultiReceipt || !this.hasServiceFee
    },
    // 「水/电费金额」「服务费金额」两列：有服务费才显示
    showSplitColumns() {
      return this.hasServiceFee
    },
    // 固定 9 列 + 单价 1 列 + 拆分 2 列
    totalColumns() {
      return 9 + (this.showUnitPriceColumn ? 1 : 0) + (this.showSplitColumns ? 2 : 0)
    }
  },
  created() {
    this.communityId = getCommunityId()
    this.userInfo = {
      userId: getUserId(),
      name: getUserName()
    }
    this.initData()
  },
  methods: {
    initData() {
      this.printPayFeeInfo.receiptId = this.$route.query.receiptId
      this.printPayFeeInfo.receiptIds = this.$route.query.receiptIds
      this.printPayFeeInfo.detailIds = this.$route.query.detailIds
      if (this.$route.query.apply) {
        this.printPayFeeInfo.apply = this.$route.query.apply
      }
      this.printPayFeeInfo.merge = this.$route.query.merge
      this.printPayFeeInfo.communityName = getCommunityName()

      this.loadReceipt()
      this.loadPrintSpec()
    },
    loadReceipt() {
      const params = {
        page: 1,
        row: 300,
        receiptId: this.printPayFeeInfo.receiptId,
        receiptIds: this.printPayFeeInfo.receiptIds,
        detailIds: this.printPayFeeInfo.detailIds,
        communityId: this.communityId
      }

      queryFeeReceipt(params).then(response => {
        const feeReceipt = response.data
        let amount = 0
        feeReceipt.forEach(item => {
          amount += parseFloat(item.amount)
        })

        this.printPayFeeInfo.amount = amount.toFixed(2)
        this.printPayFeeInfo.roomName = feeReceipt[0].objName
        this.printPayFeeInfo.feeTime = feeReceipt[0].createTime
        this.printPayFeeInfo.payObjName = feeReceipt[0].payObjName
        this.printPayFeeInfo.feeReceipt = feeReceipt
        this.printPayFeeInfo.receiptNum = feeReceipt[0].receiptCode

        this.loadReceiptDetail()
      })
    },
    loadReceiptDetail() {
      const params = {
        page: 1,
        row: 100,
        receiptId: this.printPayFeeInfo.receiptId,
        receiptIds: this.printPayFeeInfo.receiptIds,
        detailIds: this.printPayFeeInfo.detailIds,
        communityId: this.communityId,
        mergeFee: this.printPayFeeInfo.merge
      }

      queryFeeReceiptDetail(params).then(response => {
        const feeReceiptDetails = response.data
        this.printPayFeeInfo.receiptNum = this.printPayFeeInfo.receiptNum + "(" + feeReceiptDetails[0].payOrderId + ")"
        if (parseFloat(feeReceiptDetails[0].amount) < 0) {
          this.printPayFeeInfo.apply = 'R'
        }
        let acctAmount = 0.0
        let electricTotal = 0.0
        let serviceTotal = 0.0
        feeReceiptDetails.forEach(item => {
          acctAmount = acctAmount + parseFloat(item.acctAmount)
          electricTotal = electricTotal + parseFloat(item.electricAmount || 0)
          serviceTotal = serviceTotal + parseFloat(item.serviceAmount || 0)
          this.printPayFeeInfo.feeReceipt.forEach(im => {
            if (item.receiptId == im.receiptId) {
              item.objName = im.objName
              item.feeTypeCd = im.feeTypeCd
            }
          })
        })
        this.printPayFeeInfo.fees = feeReceiptDetails
        this.printPayFeeInfo.acctAmount = acctAmount.toFixed(2)
        this.printPayFeeInfo.electricTotal = electricTotal.toFixed(2)
        this.printPayFeeInfo.serviceTotal = serviceTotal.toFixed(2)
        this.printPayFeeInfo.splitTotal = (electricTotal + serviceTotal).toFixed(2)
      })
    },
    loadPrintSpec() {
      const params = {
        page: 1,
        row: 1,
        specCd: 2020,
        communityId: this.communityId
      }

      queryFeePrintSpec(params).then(response => {
        const data = response.data
        if (data.length > 0) {
          this.printPayFeeInfo.content = data[0].content
          this.printPayFeeInfo.qrImg = data[0].qrImg
          if (data[0].printName) {
            this.printPayFeeInfo.communityName = data[0].printName
          }
        }
      })
    },
    isMeterFee(item) {
      return !!item.preDegrees
    },
    isRefund(item) {
      return parseFloat(item.amount || 0) < 0
    },
    formatElectricAmount(electricAmount) {
      if (electricAmount === null || electricAmount === undefined || electricAmount === '') {
        return '—'
      }
      return parseFloat(electricAmount).toFixed(2)
    },
    formatServiceAmount(serviceAmount) {
      if (serviceAmount === null || serviceAmount === undefined || serviceAmount === '') {
        return '—'
      }
      const amount = parseFloat(serviceAmount)
      return amount === 0 ? '—' : amount.toFixed(2)
    },
    formatDiscount(discountPrice) {
      if (discountPrice === null || discountPrice === undefined || discountPrice === '') {
        return '0.00'
      }
      return parseFloat(discountPrice).toFixed(2)
    },
    dateFormat(date) {
      if (!date) return ''
      return dateFormat(date)
    },
    changeNumMoneyToChinese,
    handlePrint() {
      this.printFlag = '1'
      document.getElementById("print-btn").style.display = "none"
      window.print()
      window.close()
    },
    handleClose() {
      window.close()
    }
  }
}
</script>

<style scoped>
.print-pay-fee-container {
  padding: 20px;
}

.float-left {
  float: left;
}

.float-right {
  float: right;
}

.text-center {
  text-align: center;
}

.text-right {
  text-align: right;
}

.el-row {
  width: 100%;
  margin-bottom: 20px;
}

.el-col {
  width: 100%;
}
</style>
